import { useState } from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import Swal from 'sweetalert2';

export default function SearchDevicesIdDialog({ isOpen, onClose }) {
  const [deviceId, setDeviceId] = useState('');
  const [userEmail, setUserEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async () => {
    if (!deviceId) {
      setError('Device ID is required');
      return;
    }

    setIsLoading(true);
    setError(null);
    setUserEmail(null);

    try {
      const response = await fetch("http://127.0.0.1:8000/search_user", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ device: deviceId }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to search user');
      }

      if (data.devices && data.devices.length > 0) {
        setUserEmail(data.devices[0]); // Get the first (and should be only) user email
      } else {
        setUserEmail(null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setDeviceId('');
    setUserEmail(null);
    setError(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
      <DialogPanel className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4">
        <DialogTitle className="flex justify-between text-2xl font-bold mb-6 text-gray-800">
          Search Device Owner
          <button
            onClick={handleClose}
            className="px-2 rounded-lg text-gray-400 hover:text-red-400 transition-colors"
          >
            ×
          </button>
        </DialogTitle>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label htmlFor="deviceId" className="block text-sm font-medium text-gray-700 mb-1">
              Device ID
            </label>
            <div className="flex gap-2">
              <input
                id="deviceId"
                type="text"
                value={deviceId}
                onChange={(e) => setDeviceId(e.target.value)}
                className="flex-1 p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter device identifier"
              />
              <button
                onClick={handleSearch}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:bg-blue-400"
                disabled={isLoading}
              >
                {isLoading ? 'Searching...' : 'Search'}
              </button>
            </div>
          </div>

          {userEmail && (
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <h3 className="font-medium text-gray-700 mb-1">Device Owner:</h3>
              <p className="text-lg font-semibold text-blue-600">{userEmail}</p>
            </div>
          )}

          {!userEmail && deviceId && !isLoading && (
            <div className="p-4 text-center text-gray-500">
              No user found for this device ID
            </div>
          )}
        </div>
      </DialogPanel>
    </Dialog>
  );
}